import { CheckoutSck } from '@space-shell/modules/sales/presentation/hooks/common/use-checkout'

class URLHelper {
  static extractOfferParams(url: string | undefined) {
    try {
      if (!url) {
        return null
      }

      const urlObj = new URL(url)
      const params = new URLSearchParams(urlObj.search)

      const off = params.get('off') || null
      const coupon = params.get('coupon') || null

      return { off, coupon }
    } catch (error) {
      return null
    }
  }

  static productPageParams(url: string | undefined): string {
    let queryParams = `?sck=${CheckoutSck.ShowCaseAccess}`
    const { off, coupon } = URLHelper.extractOfferParams(url) || {}

    if (off) {
      queryParams = queryParams.concat(`&off=${encodeURIComponent(off)}`)
    }

    if (coupon) {
      queryParams = queryParams.concat(`&coupon=${encodeURIComponent(coupon)}`)
    }

    return queryParams
  }
}

export default URLHelper
